// extracted by mini-css-extract-plugin
module.exports = {"noResultsPlaceholderContainer":"styles_noResultsPlaceholderContainer__1M9yJ"};